export type ErrorProps = {
  statusCode: number
  header: string
  subheader: string
  buttonText: string
}

export const defaultErrorProps: Omit<ErrorProps, 'statusCode'> = {
  header: 'Excuses voor het ongemak',
  subheader: 'De door jou opgevraagde pagina is niet beschikbaar.',
  buttonText: 'Home',
}
